/* src/app/pages/credit-cards/credit-cards.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
::ng-deep .credit-cards-limit-cell {
  font-weight: 500;
  color: var(--cds-text-strong);
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.credit-cards-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.management-section {
  padding: 24px;
}
.management-header {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.management-title-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}
.management-title-content .section-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--cds-text-primary);
  margin: 0;
}
.management-title-content .section-subtitle {
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  color: var(--cds-text-medium);
}
.search-input-wrapper {
  margin-bottom: 8px;
  width: min(100%, 340px);
}
.credit-cards-list {
  margin-top: 8px;
}
.credit-cards-error {
  padding: 16px 0px;
}
.pagination-wrapper {
  margin-top: 12px;
}
.pagination-wrapper cds-pagination {
  justify-content: center;
}
@media (max-width: 768px) {
  :host {
    padding: 20px 16px;
  }
  .search-input-wrapper {
    width: 100%;
  }
  .management-title-content .section-title {
    font-size: 20px;
  }
  .management-section {
    padding: 18px;
  }
}
/*# sourceMappingURL=credit-cards.component.css.map */
